export class SavedSearch {
  id: number;
  userIdentifier: string;
  userName: string;
  internal: boolean;
  searchName: string;
  createdDate: Date;
  lastUsedDate: Date;
  search: string;
  recordDeleted: boolean;
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/model/saved-search.model.ts